import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ISoundPlayer, SoundTrack } from './iSoundPlayer';
import { SoundMsgMngrService } from '../../../msg/sound-msg-mngr.service';
import { AppConfig } from '../../../app.config';

@Component({
  selector: 'app-soundplayer',
  templateUrl: './soundPlayer.component.html',
  styleUrls: ['./../../aro.component.scss', './soundPlayer.componant.scss'],
})
export class SoundPlayerComponent implements OnInit, ISoundPlayer, OnDestroy {
  @Input() public Player: AudioContext;
  @Output() EqClicked = new EventEmitter<void>();
  @Output() NewSource = new EventEmitter<AudioBufferSourceNode>();
  @ViewChild('Header', { read: ElementRef }) Header: ElementRef;
  sensorBsonLoopRunning;
  sensorFolderName: string; 
  
  PlayList: Array<SoundTrack> = [];
  // Display Data...
  Title: string = "";
  Err: string = "";

  // Player State
  IsWaiting: boolean;
  PlayStop: boolean;


  constructor(protected dialog: MatDialog, protected soundService: SoundMsgMngrService) {
  }

  ngOnInit() {
    this.soundService.SensorID.subscribe(x => {
      this.reset();
    });
  }

  ngOnDestroy(): void {
    this.reset();
  }

  // toggleBsonLoop(){
  //   if (!this.Player){
  //     this.Player = new AudioContext();
  //   }
  //   this.sensorBsonLoopRunning = !this.sensorBsonLoopRunning;
  //   if (this.sensorBsonLoopRunning) { // start playing now!
  //     this.soundService.setPlayerInstance(this);
  //     this.IsWaiting = true; // will trigger the loading animation...
  //     this.soundService.startAssetsBsonFetchLoop();
  //   }
  //   else { // stop playing now!
  //     // send switch action to maxim to stop sending links to me...
  //     this.IsWaiting = false;
  //     this.soundService.stopAssetsBsonFetchLoop();
  //     this.PlayList = []
  //   }
  // }

  playStopSound(PlaybackSecs: number = 0) {
    this.PlayStop = !this.PlayStop;
    if (this.PlayStop) { // start playing now!
      // send switch action to maxim to start sending links to me...
      this.IsWaiting = true; // will trigger the loading animation...

      // enable me back so i can actually play audio...
      this.soundService.subscribeMe(this, PlaybackSecs);
    }
    else { // stop playing now!
      // send switch action to maxim to stop sending links to me...
      this.IsWaiting = false;
      // this.Player.suspend();
      this.PlayList = [];

      this.soundService.disconnect();
    }
  }

  onEnded() {
    if (this.PlayList) {
      if (this.PlayList.length > 0) {
        // make sure to rease the source from the memory...
        this.PlayList[0].Source.stop();
        this.PlayList[0].Source.disconnect();
        this.PlayList.splice(0, 1);
        if (this.PlayList.length > 0) {
          this.setSoundTrack(this.PlayList[0]);
        }
        else {
          this.IsWaiting = true;
          this.Title = "...";
        }
      }
    }
  }

  setSoundTrack(track: SoundTrack) {
    if (track != undefined) {
      this.Title = track.Time.toLocaleTimeString();

      const Source = track.Source;
      this.NewSource.emit(Source);
      Source.connect(this.Player.destination);
      Source.onended = () => this.onEnded();
      Source.start(0); // if there is any playback trouble(if there is void sound or and start disturbances) try setting to 0.01 or 0.1
    }
    else {
      this.Title = '...';
    }
  }

  public addToQueue(AudioTrack: SoundTrack) {
    this.PlayList.push(AudioTrack);
    if (this.PlayList.length > AppConfig.settings.soundAddress.buffer && this.IsWaiting) { // this mechanism makes sure we start playing only when we accumilated num of buffers...
      this.IsWaiting = false;
      this.setSoundTrack(this.PlayList[0]);
    }
  }

  onEQClick() {
    this.EqClicked.emit();
  }

  reset(): void {
    this.soundService.disconnect();
    this.IsWaiting = false;
    this.PlayList = [];
    this.PlayStop = false;
  }
}

